attribute vec4 tangent;
varying vec2 vUv;
varying vec3 vWorldPos;
varying vec3 vNormal;
varying mat3 vTbn;

void main(){
    vUv=uv;
    vNormal=normalize(mat3(modelMatrix)*normal);
    vec4 wp4=modelMatrix*vec4(position,1.);
    vWorldPos=wp4.xyz;
    
    vec3 t=normalize(mat3(modelMatrix)*tangent.xyz);
    vec3 n=normalize(mat3(modelMatrix)*normal);
    vec3 b=normalize(cross(t,n));
    vTbn=mat3(t,b,n);
    
    gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);
}